import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import ProjectService from "../services/ProjectService";
import pettyCashService from "../services/pettyCashService";
import StorageService from "../services/StorageService";
import { configSettings } from "../config/configSettings";
import Loading from "../components/loading";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";

export default function PettyCashView() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [entries, setEntries] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [projectBalance, setProjectBalance] = useState(0);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [loading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const emp = StorageService.loginData();
  const isAdmin = Number(emp.roleId) === 1 || Number(emp.roleId) === 2;

  const calculateProjectBalance = (list) => {
    if (!Array.isArray(list)) return 0;
    let totalReceipt = 0;
    let totalPayment = 0;
    list.forEach((e) => {
      if (fromDate && toDate) {
        if (e.pettycashDate < fromDate || e.pettycashDate > toDate) return;
      }
      totalReceipt += Number(e.receiptAmount || 0);
      totalPayment += Number(e.paymentAmount || 0);
    });
    return totalReceipt - totalPayment;
  };

  const showMessage = (msg, type = "error") => {
    setMessage(msg);
    setMsgType(type);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Petty_Cash,
    showMessage
  );

  useEffect(() => {
    if (permission) {
      checkView();
    }
  }, [permission]);

  // const handleSearch = async () => {
  //   if (!fromDate || !toDate) {
  //     setMessage("Please select From Date and To Date");
  //     setMsgType("danger");
  //     return;
  //   }

  //   try {
  //     const emp = StorageService.loginData();
  //     const comp = StorageService.activeCompany();

  //     const data = await pettyCashService.searchByDate({
  //       companyId: comp.companyId,
  //       employeeId: emp.employeeId,
  //       fromDate,
  //       toDate,
  //     });

  //     setEntries(data || []);
  //     setProjectBalance(calculateProjectBalance(data || []));
  //   } catch (err) {
  //     console.error(err);
  //     setEntries([]);
  //     setProjectBalance(0);
  //     setMessage("Failed to fetch data");
  //     setMsgType("danger");
  //   }
  // };

  const loadLiveFilteredEntries = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      setLoading(true);
      const data = await pettyCashService.searchByDate({
        companyId: comp.companyId,
        employeeId: isAdmin ? selectedEmployeeId : emp.employeeId,
        fromDate,
        toDate,
        projectId: selectedProjectId || null,
        page: currentPage,
        limit: itemsPerPage,
      });
      // setEntries(data?.data?.data || []);
      // setPageCount(data?.data?.pagination?.totalPages || 0);
      // setProjectBalance(calculateProjectBalance(data?.data?.data || []));

      setEntries(data?.data || []);

      setPageCount(data?.pagination?.totalPages || 0);

      setProjectBalance(
        calculateProjectBalance(data?.data || [])
      );

    } catch (err) {
      console.error(err);
      setEntries([]);
      setProjectBalance(0);
    } finally {
      setLoading(false);  //  STOP LOADING
    }

  };

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedEmployeeId, selectedProjectId, fromDate, toDate]);


  useEffect(() => {
    if (permission && checkView()) {
      loadLiveFilteredEntries();
    }
  }, [
    fromDate,
    toDate,
    selectedProjectId,
    selectedEmployeeId,
    currentPage,
    permission
  ]);



  //     useEffect(() => {
  //   if (message) {
  //     const timer = setTimeout(() => setMessage(""), 3000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [message]);

  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS BY COMPANY
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName
  //       }));
  //     }
  //     //  NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       console.log("Projects dropdown data:", projects);
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };


  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN → ALL COMPANY PROJECTS
      if (Number(emp.roleId) === 1) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          id: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode,
        }));
      }
      // NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          id: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode,
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };


  const loadEmployees = async () => {
    const comp = StorageService.activeCompany();
    const res = await pettyCashService.getEmployeesByCompany(comp.companyId);
    setEmployees(res.data);
  };

  const loadEntries = async (projectId = null) => {
    try {
      const emp = StorageService.loginData();
      const comp = StorageService.activeCompany();

      let response;

      // SUPER ADMIN → ALL PETTY CASH
      if (
        Number(emp.roleId) === 1
        || Number(emp.roleId) === 2
      ) {
        response = projectId
          ? await pettyCashService.getByProject(projectId, comp.companyId)
          : await pettyCashService.getAll(comp.companyId, currentPage, itemsPerPage);
      }
      // EMPLOYEE → ONLY THEIR PETTY CASH
      else {
        response = projectId
          ? await pettyCashService.getByProject(projectId)
          : await pettyCashService.getByEmployee(
            emp.employeeId,
            comp.companyId
          );

      }

      const list = Array.isArray(response?.data)
        ? response.data
        : response;
      if (fromDate) {
        response = list.filter(
          (e) => new Date(e.pettyCashDate) >= new Date(fromDate)
        );
      }

      if (toDate) {
        list = list.filter(
          (e) => new Date(e.pettyCashDate) <= new Date(toDate)
        );
      }
      setEntries(list);
      setProjectBalance(calculateProjectBalance(list));
    } catch (err) {
      console.error(err);
      setEntries([]);
      setProjectBalance(0);
    }
  };



  useEffect(() => {
    loadProjects();
    loadEmployees();

    const emp = StorageService.loginData();

    if (!(Number(emp.roleId) === 1 || Number(emp.roleId) === 2)) {
      setSelectedEmployeeId(emp.employeeId); // 🔒 lock to self
    }
  }, []);


  // useEffect(() => {
  //   loadEntries(null);
  // }, []);

  const handleSelect = (entry) => {
    setSelectedEntry(selectedEntry?.id === entry.id ? null : entry);
  };

  const toggleStatus = async (entry) => {
    if (!can("canModify")) {
      showMessage("No permission");
      return;
    }
    const newStatus = entry.status === "Active" ? "Inactive" : "Active";
    if (!window.confirm(`Are you sure you want to change status to ${newStatus}?`)) return;

    try {
      await pettyCashService.updateStatus(entry.id);
      setMessage("Status updated successfully");
      setMsgType("success");
      loadEntries(selectedProjectId);
    } catch {
      setMessage("Failed to update status");
      setMsgType("error");
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="Petty Cash View" secondTitle="Cash" />


      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="row">
        {/* Filters */}
        <div className="card p-3 mb-3 d-flex justify-content-between align-items-end flex-row">

          <div style={{ width: "220px" }}>
            <label className="form-label">Employee</label>
            <select
              className="form-select"
              value={selectedEmployeeId}
              disabled={!isAdmin}
              onChange={(e) => {
                if (!isAdmin) return;
                setSelectedEmployeeId(e.target.value);
                setSelectedEntry(null);
              }}
            >
              {/* Admin placeholder */}
              {isAdmin && <option value="">Select Employee</option>}

              {/* 🔒 Non-admin fallback (shows immediately) */}
              {!isAdmin && (
                <option value={emp.employeeId}>
                  {emp.firstName} {emp.lastName}
                </option>
              )}

              {/* Normal options */}
              {(isAdmin
                ? employees
                : employees.filter(e => e.id === emp.employeeId)
              ).map((e) => (
                <option key={e.id} value={e.id}>
                  {e.firstName} {e.lastName}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "220px" }}>
            <label className="form-label">Project</label>
            <select
              className="form-select"
              value={selectedProjectId}
              onChange={(e) => {
                const pid = e.target.value;
                setSelectedProjectId(pid);
                setSelectedEntry(null);
              }}
            >
              <option value="">Select Project</option>
              {projects.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.projectName}-{p.projectCode}
                </option>
              ))}
            </select>
          </div>
          <div className="me-3" style={{ width: "220px" }}>
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="me-3" style={{ width: "200px" }}>
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          {/* Balance Amount + Add Button */}
          <div style={{ display: "flex", alignItems: "flex-end", gap: "10px" }}>
            <div>
              <label className="form-label">Balance Amount</label>
              <input
                type="text"
                className="form-control"
                value={`₹ ${Number(projectBalance || 0).toFixed(3)}`}
                disabled
              />
            </div>

          </div>
        </div>

        {/* Entries Table */}
        <div className="card">
          <div className="card-header">
            {/* <h5 className="float-start">Petty Cash Entries</h5> */}
            <div className="align-self-end float-end">
              {can("canAdd") && (
                <button
                  className="btn btn-success"
                  onClick={() => navigate("/cpnl/pettycash/add")}
                >
                  <i className="ti ti-plus me-1"></i> Add
                </button>
              )}
            </div>
          </div>
          <div className="card-body">
            {/* {message && <div className={`alert alert-${msgType} py-2`}>{message}</div>} */}

            <div
              style={{
                maxHeight: "65vh",
                overflowY: "auto",
                overflowX: "auto",
                width: "100%",
              }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>Project Name</th>
                    <th>Paid to Employee </th>
                    <th>Details</th>
                    <th>Mode Of Payment</th>
                    <th>Receipt Amount</th>
                    <th>Payment Amount</th>
                    <th>Receipt</th>

                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <Loading />
                      </td>
                    </tr>
                  ) : entries.length > 0 ? (
                    entries.map((e, idx) => (
                      <tr key={e.id} className={selectedEntry?.id === e.id ? "table-active" : ""}>

                        {/* <td>{idx + 1}</td> */}
                        <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                        <td>{utility.formatDateDDMMMYYYY(e.pettycashDate)}</td>
                        <td>{e.projectName}
                          {e.projectCode ? ` - ${e.projectCode}` : ""}
                        </td>
                        <td>{e.employeeName}</td>
                        <td>{e.Details}</td>
                        <td>{e.modeOfPayment}</td>
                        <td>{e.receiptAmount != null
                          ? Number(e.receiptAmount).toFixed(3)
                          : "-"}</td>
                        <td>{e.paymentAmount != null
                          ? Number(e.paymentAmount).toFixed(3)
                          : "-"}</td>
                        <td>
                          {e.receiptURL ? (
                            <a
                              href={`${configSettings.mediaURL}/get/pettyCash/${e.receiptURL}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center text-muted">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <ReactPaginate
                // forcePage={currentPage - 1}
                forcePage={Math.max(0, currentPage - 1)}
                breakLabel="..."
                nextLabel="Next >"
                previousLabel="< Previous"
                onPageChange={(e) => setCurrentPage(e.selected + 1)}
                pageCount={pageCount}   // ✅ IMPORTANT
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
